export const getQuestionIdByType = (type: IQuestionTypeEnum) => {
	switch (type) {
		case "TEXT":
			return 1;

		case "RADIO":
			return 2;

		case "SELECT":
			return 3;

		case "HEADING":
			return 4;

		case "DATE":
			return 5;

		case "OBSERVATION_DATE":
			return 6;

		case "CC_EMAIL_RECIPIENT":
			return 7;

		case "IMAGE_UPLOAD":
			return 8;

		case "EMPLOYEE_SELECTION":
			return 9;

		default:
			return 0;
	}
};
